import React, { useState } from "react";
import { Modal } from "antd";
import styles from "./style.module.css";

const BlockedModal = ({
  isBlockedModalVisible,
  handleCancel,
  data,
  role,
  handleOk,
  title,
  Message,
  setMessage,
}) => {
  return (
    <Modal
      title={title}
      footer
      closable
      open={isBlockedModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      style={{ top: 200 }}
    >
      <div className="row">
        <div className="form-group">
          <label
            htmlFor="exampleFormControlTextarea1 fw-bold"
            className="fs_14"
          >
            {role === "teacher"
              ? `Are you sure you want to ${
                  data.isBlocked ? "unblock" : "block"
                } this teacher?`
              : `Are you sure you want to ${
                  data.isBlocked ? "unblock" : "block"
                } this student?`}
          </label>
          {/* <textarea
            class={`form-control shadow ${styles.border_color}`}
            id="exampleFormControlTextarea1"
            rows="3"
            value={Message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea> */}
        </div>
        <div className="text-right">
          <button
            onClick={handleCancel}
            className="btn btn_outlined fs_12 btn-sm text-danger px-3 py-1 mr-2"
          >
            No
          </button>
          <button
            onClick={handleOk}
            className="btn btn_contained_black fs_12 btn-sm text-white px-3 py-1"
          >
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default BlockedModal;
